export default __webpack_public_path__ + "locales/es/Common.json?hash=fdf633111c3a1b4de2e7e9414e021f9d";